import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getNonManageablePrependedGallectionsCount, getCurrentFolderId, } from '../selectors';
import { getGallectionStreamId } from '../helpers';
import { MediaSourceType } from '../types';
function moveGallectionToPosition(action) {
    var _a, folderId, position, moveType, mediaSource, currentFolderId, nonManageablePrependedGallectionsCount, streamId, params;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, folderId = _a.folderId, position = _a.position, moveType = _a.moveType;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                return [4 /*yield*/, select(getNonManageablePrependedGallectionsCount)];
            case 3:
                nonManageablePrependedGallectionsCount = _b.sent();
                streamId = getGallectionStreamId(mediaSource, currentFolderId);
                if (!(!moveType || moveType === 'streamOnly')) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actions.moveItem({ streamId: streamId, item: folderId, position: position }))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                if (!(!moveType || moveType === 'papiOnly')) return [3 /*break*/, 7];
                params = {
                    folderid: folderId,
                    type: mediaSource === MediaSourceType.GALLERY ? 'gallery' : 'collection',
                    position: position - nonManageablePrependedGallectionsCount,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update_order',
                        data: params,
                    })];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export default moveGallectionToPosition;
//# sourceMappingURL=moveGallectionToPosition.js.map